function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const radioGroupStyles = process.env.NODE_ENV === "production" ? {
  name: "1x2a5pd",
  styles: "gap:16px"
} : {
  name: "1o6j6ge-radioGroupStyles",
  styles: "gap:16px;label:radioGroupStyles;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL2NpcmNsZWNpL3Byb2plY3QvYXNjZW5kL3NyYy9jb21wb25lbnRzL1JhZGlvR3JvdXAvUmFkaW9Hcm91cC5zdHlsZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRW1DIiwiZmlsZSI6Ii9ob21lL2NpcmNsZWNpL3Byb2plY3QvYXNjZW5kL3NyYy9jb21wb25lbnRzL1JhZGlvR3JvdXAvUmFkaW9Hcm91cC5zdHlsZXMudHMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5cbmV4cG9ydCBjb25zdCByYWRpb0dyb3VwU3R5bGVzID0gY3NzYFxuICBnYXA6IDE2cHg7XG5gO1xuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
export {
  radioGroupStyles
};
//# sourceMappingURL=RadioGroup.styles.js.map
